module.exports = __webpack_public_path__ + "static/media/Used Cat Off-Highway Trucks - Toromont Cat.51831a60.jpg";